import { render } from "./DiffTagListCompare.vue?vue&type=template&id=427bcd12&scoped=true"
import script from "./DiffTagListCompare.vue?vue&type=script&lang=js"
export * from "./DiffTagListCompare.vue?vue&type=script&lang=js"

import "./DiffTagListCompare.vue?vue&type=style&index=0&id=427bcd12&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427bcd12"]])

export default __exports__